import { Heading1 } from "@/components/podkit/typography/Headings";
import { Text } from "@/components/podkit/typography/Text";
import { cn } from "@/components/podkit/lib/cn";
import { forwardRef, type ReactNode } from "react";

type PermissionDeniedProps = {
    icon: ReactNode;
    title: string;
    description: ReactNode;
    className?: string;
    "data-testid"?: string;
};

export const PermissionDenied = forwardRef<HTMLDivElement, PermissionDeniedProps>(
    ({ icon, title, description, className, "data-testid": dataTestId }, ref) => {
        return (
            <div
                ref={ref}
                className={cn("flex flex-1 flex-col items-center justify-center rounded-xl border border-border-subtle p-6 md:p-12", className)}
                role="alert"
                aria-live="polite"
                data-testid={dataTestId}
            >
                <div className="flex flex-col items-center gap-4 text-center">
                    <div className="flex size-12 items-center justify-center rounded-lg bg-surface-muted" aria-hidden="true">
                        {icon}
                    </div>
                    <div className="flex flex-col gap-2">
                        <Heading1 className="text-2xl">{title}</Heading1>
                        <Text className="text-base text-content-strong">{description}</Text>
                    </div>
                </div>
            </div>
        );
    },
);

PermissionDenied.displayName = "PermissionDenied";
